import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { Translate } from '@dreryk/react-common';
import { Text, TextSeparator, TextSeparatorType, ValueRendererProps } from '@dreryk/react-components';

export {
   getPatientAuthorizationIdentifierTypeTranslableText,
   getPatientAuthorizationIdentifierValue,
} from '~libs.desktop.shared.patient-authorization';

import {
   formatPatientAuthorizationName,
   getPatientAuthorizationIdentifierTypeTranslableText,
   getPatientAuthorizationIdentifierValue,
} from '~libs.desktop.shared.patient-authorization';

import { StyledPatientCell, StyledPatientName } from './PatientCell.styled';

export const PatientCell = (props: ValueRendererProps<MedicalDataAccessAuthorization, string>): JSX.Element => {
   return (
      <StyledPatientCell>
         <StyledPatientName>{formatPatientAuthorizationName(props.bean)}</StyledPatientName>
         <TextSeparator separator={TextSeparatorType.COLON_SPACE}>
            <Text testId={'identifierType'}>
               <Translate>{getPatientAuthorizationIdentifierTypeTranslableText(props.bean)}</Translate>
            </Text>
            <Text testId={'identifierValue'}>{getPatientAuthorizationIdentifierValue(props.bean)}</Text>
         </TextSeparator>
      </StyledPatientCell>
   );
};
